import SuggestedEditIcon from '@atlaskit/icon-lab/core/suggested-edit';
import * as React from 'react';

export function SvgSuggestedEdit() {
  return <SuggestedEditIcon label="" testId="ads-refreshed-icon" />;
}
